import { Navigate } from 'react-router-dom';
import { CUSTOMER_INTENT_EYE_EXAMINATIONS } from '@/modules/customers/intents';

/**
 * Where the Eye examinations menu entry and the dashboard's quick action lead.
 *
 * There is no clinic-wide examination list: an examination is opened from its customer. So this lands on the customer list, which explains that, with the reason carried in router state rather than the URL.
 */
export function EyeExaminationsEntry() {
  return <Navigate to="/customers" replace state={{ intent: CUSTOMER_INTENT_EYE_EXAMINATIONS }} />;
}
